(function () {
  'use strict';

  function format(value) {
    return String(value == null ? '' : value)
      .replace(/(\d(?:[\d.,/]*))\s*[x\u00d7]\s*(?=\d)/gi, '$1 \u00d7 ')
      .replace(/(\d(?:[\d.,/]*))\s*(millimetres|millimeters|centimetres|centimeters|inches|inch|mm|cm|in)(?=\b|\s|\)|$)/gi, function (_, number, unit) {
        var normalizedUnit = /^(?:inches|inch)$/i.test(unit) ? 'in' : unit;
        return number + ' ' + normalizedUnit;
      })
      .trim();
  }

  function formatProductSizeLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.variant-input-wrap[data-index="option1"] .variant__button-label-text, .um-size-display, [js-product="stickyAddToCartVariant"], [js-product="priceConfigLabel"]').forEach(function (node) {
      var formatted = format(node.textContent);
      if (formatted !== node.textContent) node.textContent = formatted;
    });
  }

  window.UMSizeDisplay = window.UMSizeDisplay || {};
  window.UMSizeDisplay.format = format;
  window.UMSizeDisplay.formatProductSizeLabels = formatProductSizeLabels;

  function scheduleFormat() {
    window.requestAnimationFrame(function () {
      formatProductSizeLabels(document);
    });
  }

  document.addEventListener('cart:build', scheduleFormat);
  document.addEventListener('cart:updated', scheduleFormat);
  document.addEventListener('ajaxProduct:added', scheduleFormat);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      formatProductSizeLabels(document);
    }, { once: true });
  } else {
    formatProductSizeLabels(document);
  }
})();
